import request from "../../utils/request";

export function getAllContacts(params) {
  return request("/contact-locations", {
    method: "GET",
    params,
  });
}

export function doUploadContacts(params) {
  return request("/contact-locations/upload", {
    method: "POST",
    data: params,
  });
}

export function doCreateContact(params) {
  return request("/contact-locations", {
    method: "POST",
    data: params,
  });
}

export function doUpdateContact(params) {
  return request(`/contact-locations/${params.id}`, {
    method: "PUT",
    data: params,
  });
}

export function doDeleteContact(id) {
  return request(`/contact-locations/${id}`, {
    method: "DELETE",
  });
}

export function doDeleteContacts(data) {
  return request("/contact-locations/bulk-delete", {
    method: "POST",
    data,
  });
}
